import React from 'react';
import { Divider } from '../../../../components';
import AccommodationFilter from './modules/accommodation-filter';
import AccommodationCategory from './modules/accommodation-category';
import AccommodationRoomOccupancy from './modules/accommodation-room-occupancy';
import { useTranslate } from "../../../../features/translation/hooks/use-translation";



const AccommodationPreferences = () => {
    const { t } = useTranslate();

    return (
        <div className="container">
            <div className="row">
                 <div className="col col-12">
                        <Divider className="horizontal thin primary text-title " label={t("form.accommodationPreferences.title")}/>
                    </div>
                </div>
            <div className="row" style={{paddingTop:"var(--space-4)", paddingBottom:"var(--space-8)"}}>
                <div className="col col-12">
                    <div className="text base" style={{textAlign:"center"}} dangerouslySetInnerHTML={{ __html: t("form.accommodationPreferences.description")}} />

                </div>
            </div>
            <div className="row">
                <div className="col col-12">
                    <AccommodationCategory />
                </div>
            </div>
            <div className="row">
                <div className="col col-12">
                    <AccommodationRoomOccupancy />
                </div>
            </div>
            <div className="row">
                <div className="col col-12">
                    <AccommodationFilter />
                </div>
            </div>    
        </div>
    );
};

export default AccommodationPreferences;